import { Lightbulb, EnvelopeSimple, ArrowRight } from "@phosphor-icons/react";

/**
 * Inline feedback CTA. Three visual variants for different page contexts.
 *
 * <FeedbackCTA variant="strip" />     Subtle one-liner, e.g. below a list page
 * <FeedbackCTA variant="card" />      Larger card with icon, for empty states / about / dashboard
 * <FeedbackCTA variant="inline" />    Plain text link, for inside body copy
 */
export default function FeedbackCTA({
  variant = "card",
  prompt = "Got an idea, a missing feature, or a retailer you'd love us to support?",
  subject = "Idea for PriceGuard NZ",
  className = "",
}) {
  const href = `mailto:hello@priceguard.nz?subject=${encodeURIComponent(subject)}`;

  if (variant === "strip") {
    return (
      <div className={`flex items-center gap-2 flex-wrap text-xs font-mono-pg text-[#52525b] ${className}`} data-testid="feedback-cta-strip">
        <Lightbulb size={14} weight="duotone" color="#002FA7" />
        <span>{prompt}</span>
        <a
          href={href}
          className="font-bold text-[#002FA7] hover:text-[#00207A] underline underline-offset-2"
          data-testid="feedback-cta-strip-link"
        >
          hello@priceguard.nz
        </a>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <a
        href={href}
        className={`text-[#002FA7] font-bold underline hover:text-[#00207A] ${className}`}
        data-testid="feedback-cta-inline-link"
      >
        hello@priceguard.nz
      </a>
    );
  }

  // Default: card
  return (
    <div className={`border border-[#e4e4e7] bg-white p-6 flex flex-wrap items-start gap-4 ${className}`} data-testid="feedback-cta-card">
      <div className="bg-[#EFF1FB] border border-[#002FA7] p-3 flex-shrink-0">
        <Lightbulb size={22} weight="duotone" color="#002FA7" />
      </div>
      <div className="flex-1 min-w-[220px]">
        <div className="pg-overline text-[#002FA7]">Help shape PriceGuard</div>
        <h3 className="font-heading font-bold tracking-tight mt-1">{prompt}</h3>
        <p className="text-[#52525b] text-sm mt-2 leading-relaxed">
          We read every message. Tell us what would make this more useful for your household and we'll often ship it the same week.
        </p>
        <a
          href={href}
          className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-[#002FA7] hover:text-[#00207A]"
          data-testid="feedback-cta-card-link"
        >
          <EnvelopeSimple size={14} weight="bold" /> hello@priceguard.nz <ArrowRight size={14} weight="bold" />
        </a>
      </div>
    </div>
  );
}
